<style scoped>
    .table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
        padding: 5px;
        line-height: 3;
        vertical-align: central;
        border-top: 1px solid #dddddd
    }

    .drugColumn {
        min-width: 150px;
    }
    .form-control {
        padding-right: 7px;
        padding-left: 7px;
    }
</style>
<template>
    <div class="col-md-12">
        <div class="row">
            <ul class="nav nav-pills pull-right">
                <li class="dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                        <strong>{{currentCycleTitle}}</strong> ( {{formatDate(cycleStartDate)}} - {{formatDate(cycleEndDate)}} )<span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu">
                        <template v-for="(cycle, index) in cycles">
                            <template v-if="index==0">
                                <li>
                                    <a @click.prevent.self="setCycle(cycle)">
                                        <strong class="text-primary">Next</strong><br />
                                        {{formatDate(cycle.startDate)}} - {{formatDate(cycle.endDate)}}
                                    </a>
                                </li>
                                <li class="divider"></li>
                            </template>

                            <template v-if="index==1">
                                <li>
                                    <a @click.prevent.self="setCycle(cycle)">
                                        <strong class="text-danger"> Current</strong><br />
                                        {{formatDate(cycle.startDate)}} - {{formatDate(cycle.endDate)}}
                                    </a>
                                </li>
                                <li class="divider"></li>
                            </template>

                            <template v-if="index>1">
                                <li>
                                    <a @click.prevent.self="setCycle(cycle)">
                                        {{formatDate(cycle.startDate)}} - {{formatDate(cycle.endDate)}}
                                    </a>
                                </li>
                            </template>
                        </template>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="row">
            <!--<LoaderControl :loading="isLoading">-->
            <transition name="fade" :duration="1000">
                <div v-if="this.isLoading" style="width:100%; position:absolute; top:100px;text-align:center; vertical-align:central">

                    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                    <span class="sr-only">Loading...</span>

                </div>
            </transition>
            <div>
                <table class="table" style="min-height:100px">
                    <thead>
                        <tr>
                            <th style="width:18px"></th>
                            <th style="min-width:200px">Drug</th>
                            <!--<th>Instruction</th>-->
                            <th style="width:80px">Quantity</th>
                            <th style="min-width:150px">Notes</th>
                            <th style="width:90px">Start Date</th>
                            <th style="width:90px">End Date</th>
                            <th style="width:150px">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in controller.OrderItems" v-bind:class="{ 'active': !item.IsNew, 'info': item.IsNew && !item.hasError, 'danger' : item.IsNew && item.hasError }">
                            <template v-if="!item.IsNew">
                                <td>
                                    <button class="btn btn-link" @click.prevent.self="" style="cursor:help; padding:0px">
                                        <TooltipControl :title="StatusText(item.carehomePatientOrderItemStatus)">
                                            <i class="fa"
                                               v-bind:class="{
                                                'fa-history  text-warning': item.carehomePatientOrderItemStatus == 10,
                                                'fa-check text-primary': item.carehomePatientOrderItemStatus == 30,
                                                'fa-check-square-o text-success': item.carehomePatientOrderItemStatus == 20
                                                }">
                                            </i>
                                        </TooltipControl>
                                    </button>

                                </td>
                                <td>{{item.drug.value.searchText}}</td>
                                <!--<td class="text-right"><span>{{item.quantity.value}}</span></td>
                                <td>{{item.notes.value}}</td>-->
                                <td>
                                    <span v-bind:class="{ 'has-error' : item.quantity.hasError,'has-warning' : item.quantity.hasWarning ,'has-success' : item.quantity.hasSuccess}">
                                        <input type="text" style="height:34px;font-size:12px" class="form-control" v-model="item.quantity.value" @blur="item.quantity.value = item.quantity.value">
                                    </span>
                                </td>
                                <td><input type="text" style="height:34px;font-size:12px;width:100%" class="form-control" v-model="item.notes.value" @blur="item.notes.value = item.notes.value"></td>

                                <td>{{formatDate(item.startDate.value)}}</td>
                                <td>{{formatDate(item.endDate.value)}}</td>
                                <td><DrugStatusSelector :controller="item.orderStatus"></DrugStatusSelector></td>
                            </template>
                            <template v-else>
                                <td>
                                    <button class="btn btn-link" @click="Remove(item.index)" style="cursor:help; padding:0px">
                                        <i class="fa fa-1x fa-minus-circle"></i>
                                    </button>
                                </td>
                                <td><DrugSearchSelector :ref="'search-'+item.index" v-model="item.drug"></DrugSearchSelector></td>
                                <!--<td>{{item.instruction.value}}</td>-->
                                <td>
                                    <span v-bind:class="{ 'has-error' : item.quantity.hasError,'has-warning' : item.quantity.hasWarning ,'has-success' : item.quantity.hasSuccess}">
                                        <input type="text" style="height:34px" class="form-control" v-model="item.quantity.value" @blur="item.quantity.value = item.quantity.value">
                                    </span>
                                </td>
                                <td><input type="text" style="height:34px;width:100%" class="form-control" v-model="item.notes.value" @blur="item.notes.value = item.notes.value"></td>
                                <td>{{formatDate(item.startDate.value)}}</td>
                                <td>{{formatDate(item.endDate.value)}}</td>
                                <td><DrugStatusSelector :controller="item.orderStatus"></DrugStatusSelector></td>
                            </template>
                        </tr>
                        <tr>
                            <td colspan="8">
                                <button class="btn btn-info btn-xs" @click="AddNew" :disabled="controller.hasError">
                                    <i class="fa fa-1x fa-plus"></i>
                                    <span style="vertical-align:central">Add Row</span>
                                </button>
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
            <!--</LoaderControl>-->
            <hr />

            <div class="form-group" v-bind:class="{ 'has-error' : controller.hasError,'has-warning' : controller.hasWarning ,'has-success' : controller.hasSuccess}">
                <!--<a class="btn btn-primary" :disabled="controller.hasError" @click.prevent.self="Submit">Submit</a>-->
                <WorkerButton :disabled="controller.hasError" :submit="Submit" :callback="SubmitSuccessCallback" task="Patient Orders Saved"></WorkerButton>

                <a href="#" class="btn btn-warning" @click.prevent.self="load">Reset</a>
                <span class="help-block">{{controller.message}}</span>
            </div>
        </div>

        <!--<ServerErrorHandler v-model="hasServerError" message="There was an issue with the server. Contact Support"></ServerErrorHandler>-->
    </div>
</template>
<script>
    import { WardCycleDto, PatientOrderItemDto } from './../../../dto/Dtos';
    import Formatter from "../../corecontrols/formatters/Formatter";
    import DrugSearchSelector from "../DrugSearchSelector/DrugSearchSelector.scp.html"
    import { OrderItemController, OrderItemControllerHelper, OrderGroupController } from './OrderItemController'
    import DrugStatusSelector from "./../drugStatusSelector/drugStatusSelector.scp.html";
    import DrugQuantityEditor from "./../drugQuantityEditor/drugQuantityEditor.scp.html";
    //import ServerErrorHandler from "./../servererrorhandler/servererrorhandler.scp.html";
    import Dal from './../../../scripts/dataaccess';
    import TooltipControl from './../../corecontrols/tooltipcontrol/tooltipcontrol.scp.html';
    import LoaderControl from './../../corecontrols/loaderControl/loaderControl.scp.html';
    import WorkerButton from './../../corecontrols/workerbutton/workerbutton.scp.html';

    export default {
        props: ['patientid', 'startDate', 'endDate'],
        data: function () {
            return {
                patient: {},
                controlLoading: true,
                isLoading: true,
                cycleStartDate: undefined,
                cycleEndDate: undefined,
                currentCycleTitle: "",
                items: [],
                cycles: [],
                controller: new OrderGroupController()
            }
        },
        watch: {
            startDate: function () {
                console.log("Dates Changed Patient Orders")
                this.load();
            }, endDate: function () {
                console.log("Dates Changed Patient Orders")
                this.load();
            }, patient: function () {
                console.log("Dates Changed Patient Orders")
                this.load();
            }
        },
        mounted: function () {
            console.log("Mounting Patient Orders")
            var that = this;
            var dal = new Dal();
            dal.GetPatient(this.patientid).then(d => {
                that.patient = d;
            })
        },
        methods: {
            sleep: function (milliseconds) {
                var start = new Date().getTime();
                for (var i = 0; i < 1e7; i++) {
                    if ((new Date().getTime() - start) > milliseconds) {
                        break;
                    }
                }
            },
            setCycle: function (cycle) {
                this.currentCycleTitle = this.cycles.indexOf(cycle) == 0 ? "Next Cycle" : this.cycles.indexOf(cycle) == 1 ? "Current Cycle" : " Cycle";
                this.cycleStartDate = cycle.startDate;
                this.cycleEndDate = cycle.endDate;
                this.load();
            },
            StatusText: function (status) {
                if (status == 10) return "Not Saved";
                else if (status == 20) return "Accepted by Pharmacy";
                else if (status == 30) return "Not accepted by Pharmacy";
            },
            AddNew: function () {
                console.log("Adding new line in Order Items");
                var item = this.controller.AddNew();
                this.$nextTick(() => {
                    var ref = "search-" + item.index;
                    console.log("moving focus to ref " + ref)
                    this.$refs[ref][0].$el.focus();
                })
            },
            Remove: function (key) {
                this.controller.Remove(key)
            },
            formatDate: function (dt) {
                return Formatter.FormatDate(dt);
            },
            load: function () {
                this.isLoading = true;
                console.log("Mounting Patient Orders", this.patientid)
                var helper = new OrderItemControllerHelper();
                if (this.patientid) {
                    var dal = new Dal();
                    dal.GetWardCycles(this.patient.wardId).then(cycles => {
                        var sortedCycles = cycles.sort((n1, n2) => {
                            if (n1.startDate > n2.startDate) return -1;
                            else if (n1.startDate < n2.startDate) return 1;
                            else return 0;
                        });

                        this.cycles = sortedCycles;

                        if (!this.cycleStartDate || !this.cycleEndDate) {
                            this.cycleStartDate = sortedCycles[0].startDate;
                            this.cycleEndDate = sortedCycles[0].endDate;
                            this.currentCycleTitle = "Next Cycle"
                        }
                        //this.$nextTick(() => { this.sleep(1000) });
                        this.controlLoading = false;
                        this.controller.Load(this.patientid, this.cycleStartDate, this.cycleEndDate);
                        this.isLoading = false;
                    })
                }
                else {
                    this.isLoading = false;
                }

                this.controlLoading = false;

            },
            Submit: function () {
                console.log("Submitting Patient Orders")
                return this.controller.Submit();
            },
            SubmitSuccessCallback() {
                //this.controller = new OrderGroupController();
                this.load();
            }
        },
        components: {
            Formatter,
            LoaderControl,
            DrugStatusSelector,
            DrugQuantityEditor,
            DrugSearchSelector,
            TooltipControl,
            WorkerButton
        }
    }
</script>


// WEBPACK FOOTER //
// PatientReorderForm.scp.html?f6bf7a76